'use client';

import type { IChromeConfig } from '@repo/web-chrome/chrome-config/chrome-config';
import { ChromeConfigContext } from '@repo/web-chrome/chrome-config/chrome-config-context';
import { useContext } from 'react';

export function useOptionalChromeConfig(): IChromeConfig | null {
  return useContext(ChromeConfigContext);
}
